import React from "react";

import { DashboardPageBody } from "../../components/Page";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import MailFiltersPage from "./ui";

const MailFilters = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <DashboardPageBody>
        <MailFiltersPage />
      </DashboardPageBody>
    </DashboardLayout>
  );
};

export default MailFilters;

